import api from "./axios";

class ServiceSale {
  async save(dataSale) {
    const { data } = await api.post("/sales", dataSale);
    return data;
  }

  async createNewCompletedSale(dataSale) {
    const { data } = await api.post("/sales/create-completed-sale", dataSale);
    return data;
  }


  async createSaleWithoutProducts(dataSale) {
    const { data } = await api.post("/sales/create/without-product", dataSale);
    return data;
  }

  async updateSaleWithoutProducts(dataSale) {
    const { data } = await api.put(
      `/sales/update/without-product/${dataSale.sale.id}`,
      dataSale,
    );
    return data;
  }

  async updateCompletedSale(dataSale) {
    const { data } = await api.put(
      `/sales/update-new-completed-sale/${dataSale.sale.id}`,
      dataSale,
    );
    return data;
  }

  async update(dataSale) {
    await api.put(`/sales/${dataSale.id}`, dataSale);
  }

  async findById(idVenda) {
    const { data } = await api.get(`/sales/${idVenda}`);

    return data
  }

  async delete(id) {
    await api.delete(`/sales/${id}`);
  }

  async deleteAll(dataSaleUnique) {
    await api.delete(`/sales/all/${dataSaleUnique}`);
  }

  async transformInNotaToSend(idSale, selectedProductIds = []) {
    if (selectedProductIds.length) {
      const { data } = await api.post(
        `/sales/transform/orcamento/venda/${idSale}`,
        { selectedProductIds },
      );

      return data;
    }

    const { data } = await api.get(
      `/sales/transform/orcamento/venda/${idSale}`,
    );

    return data;
  }

  async getAllBillsById(id) {
    const { data } = await api.get(`/sales/${id}`);
    return data;
  }

  async filterSalePerMonth(month, year, typeSale) {
    const { data } = await api.get(
      `/sales/per/month/search/sum/group/six?month=${month}&year=${year}&typeSale=${typeSale}`,
    );

    return data;
  }

  // async cancelPrescription(id) {
  //   await api.post("/sales/cancel-sale/" + id);
  // }

  async cancel(id, status) {
    await api.post(`/sales/cancel/registers`, { id, status });
  }

  async reOpen(id) {
    await api.post(`/sales/reopen/after/cancel`, { id });
  }

  async updateTypeOrder(id, tipo) {
    await api.patch(`/sales/updated-type-order/${id}`, { tipo });
  }

  async findCountStatus() {
    const { data } = await api.get(`/sales/count/status`);
    return data;
  }

  async sendReport(id) {
    const { data } = await api.post(`/sales/send/report/${id}`);
    return data;
  }

  async cancelReport(id) {
    const { data } = await api.post(`/sales/cancel/report/${id}`);
    return data;
  }
}

export default new ServiceSale();
